/* eslint-disable @typescript-eslint/ban-ts-ignore */
import { createStore } from 'vuex';
import platform from 'platform';

import {
  loadFetch,
  // buidlURL,
  // invokeOnce,
  // GATEWAY,
  // GATEWAY_TW,
  // GATEWAY_TPM,
  // GATEWAY_TT,
  // dateToString,
  // getLocaleDate,
  // reachGoal,
  // currency,
  // dateFromString
} from '@/functions';
import {
  GatewayResponse, LoadingEvent, NamedUniqueElement, UrlParams,
} from '@/interface';

interface Initial {
  regions: string;
  subregions?: string;
  text?: string;
}
interface CommonInitial {
  datefrom: Date | string;
  dateto: Date | string;
  adults: string | number;
  children: string | number;
  nightsfrom: string | number;
  nightsto: string | number;
  departure: string | number;
  country: string | number;
}
const DEFAULT_INITIAL: (regions: string, subregions?: string) => Initial = (regions: string, subregions = '') => ({
  regions,
  subregions,
});

export default createStore({
  state: {
    cache: {} as { [key: string]: unknown },
    offices: null as {
      cities: { id: string; name: unknown }[];
      agencies: { id: string; city: unknown; name: unknown; code: unknown }[];
    } | null,
    city: null,
    subRegionList: [] as NamedUniqueElement[],
    regionList: [] as NamedUniqueElement[],
    initials: {
      common: {
        datefrom: new Date(),
        dateto: new Date(),
        adults: 2,
        children: 0,
        nightsfrom: 6,
        nightsto: 10,
        departure: 99,
        country: 47,
      } as CommonInitial,
      list: [] as Initial[],
    },
    options: {
      datefromindays: 7,
      datetoindays: 14,
    },
    cells: [] as { hotelIndex: number; isHotelListVisible: boolean; isMetaOpen: boolean }[],
    priceList: [],
    searchPromises: [],
    hotelList: [] as {hotelcode: string}[],

    loading: [] as string[],
    errors: [] as string[],
    status: null as { state: string } | null,
    result: [] as {regions: string; subregions: string; hotel: {
      hotelcode: number;
    }[];}[],

    tour: null as {
      tourid: string;
      hotelcode: string;
      detail: {
        flights: {
          price: {
            value: unknown;
          };
          fuelcharge: {
            value: unknown;
          };
        }[];
      };
      price: unknown;
      fuelcharge: unknown;
    } | null,
    flightNum: null as number | null,
    relatedList: [],
    cellIndex: null as number | null,

    feedback: {
      username: '',
      email: '',
      phone: '',
      office: null,
    },
    isInitialized: false,
    isSent: false,
    isSaved: false,

    stats: null as unknown | null,
    context: null as string | null,
  },
  getters: {
    netCities: (state) => {
      if (!state.offices) return [];
      return state.offices.cities;
    },
    netOffices: (state) => () => {
      if (!state.offices) return [];

      if (!state.city) return state.offices.agencies;
      return state.offices.agencies.filter((agency) => agency.city === state.city);
    },
    context: (state): string => {
      // const devOrigin = 'demo.putevkamarket.ru';
      // const devOrigin = 'https://well.ru';
      // const devOrigin = 'https://site.turdoka.ru';
      const devOrigin = 'https://chertanovo.well.ru';
      // if (
      //   typeof (window as Window & typeof globalThis).WAS_CONTEXT ===
      //     'string' &&
      //   ((window as Window & typeof globalThis)
      //     .WAS_CONTEXT as keyof typeof ContextList)
      // )
      //   return (window as Window & typeof globalThis).WAS_CONTEXT as string;
      // return 'main-pm';
      if (state.context) {
        return state.context;
      }

      const origin = process.env.NODE_ENV !== 'production'
        ? devOrigin
        : window.location.origin;
      let result;
      switch (true) {
        case origin === 'https://well.ru':
          result = 'main';
          break;
        case origin === 'https://putevkamarket.ru':
          result = 'main-pm';
          break;
        case origin === 'https://office.well.ru':
        case origin === 'https://test.well.ru':
        case origin === 'https://agent.putevkamarket.ru':
          result = 'office';
          break;
        case origin.search('.well.ru') !== -1:
          result = 'well';
          break;
        case origin.search('.putevkamarket.ru') !== -1:
          result = 'pm';
          break;
        case origin.search('.turdoka.ru') !== -1:
          result = 'td';
          break;
        default:
          // result = 'main';
          result = 'well';
          break;
      }
      return result;
    },
    isConfig: () => () => new URLSearchParams(window.location.search).get('config') !== null,
    isError: (state) => (code?: string): boolean => (!code
      ? state.errors.length > 0
      : state.errors.includes(code)),
    isLoading: (state) => (code?: string): boolean => (!code
      ? state.loading.length > 0
      : state.loading.includes(code)),
    cellResult: (state) => (index: number) => {
      const cell = state.initials.list[index || 0];

      return state.result.find(
        (result: {regions: string; subregions: string}) => result.regions === cell.regions
          && result.subregions === cell.subregions,
      );
    },
    regionById: (state) => (id: string) => state.regionList.find(
      (region) => region.id.toString() === id,
    ),
    subRegionById: (state) => (id: string) => state.subRegionList.find(
      (region) => region.id.toString() === id,
    ),
    cellHotel: (state) => (index: number) => {
      const cell = state.initials.list[index];
      // console.log(cell);
      const resultFound = state.result.find(
        (result) => {
          let sameHotel = true;
          if ((window as {WTV_HOTELS?: number[]}).WTV_HOTELS) {
            const hotels = (window as {WTV_HOTELS?: number[]}).WTV_HOTELS as number[];
            sameHotel = hotels[index] === result.hotel[0].hotelcode;
          }
          const sameRegion = result.regions === cell.regions
            && result.subregions === cell.subregions;
          return sameHotel && sameRegion;
        },
      );
      if (!resultFound || !resultFound.hotel || resultFound?.hotel?.length === 0) return false;

      // console.log(resultFound.hotel[state.cells[index].hotelIndex]);

      return resultFound.hotel[state.cells[index].hotelIndex];
    },
    tourHotel: (state) => (
      state.tour !== null
        ? state.hotelList.find(
          (hotel) => parseInt(hotel.hotelcode, 10) === parseInt(
            state.tour?.hotelcode as string, 10,
          ),
        )
        : null
    ),
    hotelInfo: (state) => (hotelcode: string) => state.hotelList.find(
      (hotel) => parseInt(hotel.hotelcode, 10) === parseInt(hotelcode, 10),
    ),
    touristStringFrom: () => (adults: string | number, child: string | number) => `${adults} взр${child > 0 ? `, ${child} реб` : ''}`,
    priceString: () => (price: string/* , currencyShort = null */) => {
      // if (!currencyShort) {
      //   const currencyFound = getters.currencyList.length
      //     ? getters.currencyList.find(c => c.id == state.params.currency)
      //     : false;
      //   currencyShort = currencyFound
      //     ? currency.find(c => c.id == currencyFound.id).name
      //     : 'RUB';
      // console.log(price);
      const currencyShort = 'RUB';
      return `${
        price
          ? parseInt(price, 10)
            .toFixed(0)
            .replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1&thinsp;')
          : 0
      } <span class="wtv-small">${currencyShort}</span>`;
    },
    // eslint-disable-next-line no-nested-ternary
    flightPrice: (state) => () => (state.flightNum === null
      ? (
        state.tour
          ? state?.tour?.price
          : 0
      )
      : state?.tour?.detail?.flights[state.flightNum].price.value),
    // eslint-disable-next-line no-nested-ternary
    flightFuelCharge: (state) => () => (state.flightNum === null
      ? state.tour
        ? state?.tour?.fuelcharge
        : 0
      : state?.tour?.detail?.flights[state.flightNum].fuelcharge.value),
    flightString: (state, getters) => {
      if (state.flightNum === null) return '';

      const el = state?.tour?.detail.flights[state.flightNum];
      // @ts-ignore
      return `Туда: ${el?.dateforward}, ${el?.forward[0].departure.port.name} - ${
        // @ts-ignore
        el?.forward[0].arrival.port.name
        // @ts-ignore
      }, ${el.forward[0].departure.time} - ${el?.forward[0].arrival.time}, ${
        // @ts-ignore
        el.forward[0].number
        // @ts-ignore
      }. Обратно: ${el?.datebackward}, ${el.backward[0].departure.port.name} - ${
        // @ts-ignore
        el.backward[0].arrival.port.name
        // @ts-ignore
      }, ${el.backward[0].departure.time} - ${el?.backward[0].arrival.time}, ${
        // @ts-ignore
        el.backward[0].number
        // @ts-ignore
      }. Цена: ${getters.priceString(el?.price.value, el?.price.currency)}`;
    },
  },
  mutations: {
    flightNum: (state, num) => {
      state.flightNum = num;
    },
    setDateFromInDays(state, value) {
      state.options = {
        ...state.options,
        datefromindays: value,
      };
    },
    setDateToInDays(state, value) {
      state.options = {
        ...state.options,
        datetoindays: value,
      };
    },
    setLoading(state, { text, set = true }: LoadingEvent): void {
      if (set) {
        state.errors = [];
        state.loading.push(text);
      } else state.loading.splice(state.loading.indexOf(text), 1);
    },
    setError(state, error: string): void {
      state.errors.push(error);
    },
    setInitials(state, { response }): void {
      if (response.regions) state.regionList = response.regions;
      if (response.subregions) state.subRegionList = response.subregions;
      if (response.lists) {
        state.offices = {
          cities: Object.entries(response.lists.CITIES)
            .map((row) => ({
              id: row[0],
              // @ts-ignore
              name: row[1].NAME,
            }))
            // eslint-disable-next-line no-nested-ternary
            .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)),
          agencies: Object.entries(response.lists.TO)
            .map((row) => ({
              id: row[0],
              // @ts-ignore
              city: row[1].CITY,
              // @ts-ignore
              name: row[1].NAME,
              // @ts-ignore
              code: row[1].CODE,
            }))
            // eslint-disable-next-line no-nested-ternary
            .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)),
        };
      }

      if (response.office) {
        state.feedback.office = response.office;
      }

      if (response.prices) {
        state.priceList = response.prices;
      }

      if (state.initials.list.length === 0 && !response.config) {
        for (let index = 0; index < 12; index += 1) {
          state.initials.list.push(DEFAULT_INITIAL('518'));
        }
      } else if (response.config) {
        state.initials = JSON.parse(response.config);
      }
      state.initials.list.forEach(() => state.cells.push(
        { hotelIndex: 0, isHotelListVisible: false, isMetaOpen: false },
      ));

      if (response.options) {
        state.options = response.options;
      }

      if (response.auth?.context) {
        state.context = response.auth.context;
        // console.log(state.context);
      }
      state.isInitialized = true;

      // Vue.set(state.initials.list[3], 'regions', '43');

      // response;
      // context;
    },
    setCell(state, { param, index, value }) {
      state.initials.list[index][param as keyof Initial] = value;
    },
    setCommon(state, { param, value }) {
      state.initials.common[param as keyof CommonInitial] = value;
    },
    setSearchPromises(state, searchPromises) {
      state.searchPromises = searchPromises;
    },
    setStatus(state, status) {
      state.status = status;
    },
    setResult(state, { initial, result }) {
      const { regions, subregions } = initial;
      state.result.push({ regions, subregions, ...result } as never);
    },
    updateHotelList(state, hotel) {
      state.hotelList.push(hotel);
    },
    setCellHotel(state, cell) {
      const { index, ...other } = cell;
      const stateCell = state.cells[index];
      state.cells[index] = { ...stateCell, ...other };
    },
    setTour(state, tour) {
      state.flightNum = null;
      state.tour = tour;
    },
    setRelatedList(state, list) {
      state.relatedList = list;
    },
    setFlightNum(state, flightNum) {
      state.flightNum = flightNum;
    },
    setCellIndex(state, cellIndex) {
      state.cellIndex = cellIndex;
    },
    updateCity(state, city) {
      state.city = city;
    },
    updateOffices(state, offices) {
      state.offices = {
        cities: Object.entries(offices.CITIES)
          .map((row) => ({
            id: row[0],
            // @ts-ignore
            name: row[1].NAME,
          }))
          // eslint-disable-next-line no-nested-ternary
          .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)),
        agencies: Object.entries(offices.TO)
          .map((row) => ({
            id: row[0],
            // @ts-ignore
            city: row[1].CITY,
            // @ts-ignore
            name: row[1].NAME,
            // @ts-ignore
            code: row[1].CODE,
          }))
          // eslint-disable-next-line no-nested-ternary
          .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)),
      };
    },
    updateFeedback(state, feedback) {
      state.feedback = { ...state.feedback, ...feedback };
    },
    setSaved(state, value = true) {
      state.isSaved = value;
    },
    setSent(state, value = true) {
      state.isSent = value;
    },
    setStats(state, value = null) {
      state.stats = value;
    },
    removeInitial(state, index) {
      state.initials.list.splice(index, 1);
    },
    addInitial(state) {
      state.initials.list.push(DEFAULT_INITIAL('518'));
    },
  },
  actions: {
    getCache({
      commit, state, dispatch,
    }, initials) {
      const body = new FormData();
      body.set('type', 'get_cache');
      body.set('initial', JSON.stringify(initials));
      return loadFetch('Getting tour', {
        method: 'POST',
        body,
      }, (response: GatewayResponse) => {
        if (response.Error) return commit('setError', response.Error);

        if (response.result && initials.hotels) {
          dispatch('getHotel', initials.hotels).then((hotelResponse) => {
            state.cache[initials.hotels as string] = {
              ...response.result,
              hotel: hotelResponse.hotel,
            };
            Object.assign(window, {
              getTour: (hotel: string) => dispatch('actualize', state.cache[hotel]),
              tours: state.cache,
            });
            document.dispatchEvent(new Event('getTourReady'));
          });
          // console.log(response.result);
        }

        return false;
      }, commit);
    },
    initialize({
      commit, state, getters, dispatch,
    }): Promise<unknown> {
      const params: UrlParams<string> = {
        type: 'init',
        // context: getters.context,
      };
      if ((window as {WTV_COUNTRY?: number}).WTV_COUNTRY) {
        params.country = ((window as {WTV_COUNTRY?: number}).WTV_COUNTRY as number).toString();
      }
      if (getters.isConfig()) {
        params.config = new URLSearchParams(window.location.search).get('config') as string;
      }

      return loadFetch('Initialization', params, (response: GatewayResponse) => {
        if (response.Error) return commit('setError', response.Error);

        commit('setInitials', { response });
        if ((window as {WTV_DEPARTURE?: number}).WTV_DEPARTURE) {
          commit('setCommon', {
            param: 'departure',
            value: (window as {WTV_DEPARTURE?: number}).WTV_DEPARTURE,
          });
          // console.log((window as {WTV_DEPARTURE?: number}).WTV_DEPARTURE);
        }
        if ((window as {WTV_COUNTRY?: number}).WTV_COUNTRY) {
          commit('setCommon', {
            param: 'country',
            value: (window as {WTV_COUNTRY?: number}).WTV_COUNTRY,
          });
          // console.log((window as {WTV_COUNTRY?: number}).WTV_COUNTRY);
        }
        if ((window as {WTV_HOTELS?: number[]}).WTV_HOTELS) {
          const hotels = (window as {WTV_HOTELS?: number[]}).WTV_HOTELS as number[];
          hotels.forEach((value, index) => {
            commit('setCell', {
              param: 'hotels',
              index,
              value,
            });
            commit('setCell', {
              param: 'regions',
              index,
              value: undefined,
            });
            commit('setCell', {
              param: 'subregions',
              index,
              value: undefined,
            });
            commit('setCell', {
              param: 'text',
              index,
              value: undefined,
            });
          });
        }

        if (!getters.isConfig()) {
          dispatch('sendStats', {
            cell: state.initials.list[0],
            type: 'initialize',
          });
        } else {
          commit('setStats', response.stats);
        }
        return false;
      }, commit);
    },
    SAVING({ commit }) {
      commit('setSaved');

      setTimeout(() => {
        commit('setSaved', false);
      }, 5000);
    },
    saveConfig({
      commit, state, dispatch,
    }) {
      console.log(state.initials);

      const body = new FormData();
      body.set('type', 'save_config');
      body.set('config', JSON.stringify(state.initials));
      body.set('options', JSON.stringify(state.options));
      // body.set('context', getters.config);
      return loadFetch('Saving config', {
        method: 'POST',
        body,
      }, (response: GatewayResponse) => {
        if (response.Error) return commit('setError', response.Error);

        dispatch('SAVING');

        return commit('setInitials', { response });
      }, commit);
    },
    getCellText({ commit, state }, index) {
      const body = new FormData();
      body.set('type', 'cell');
      body.set('initial', JSON.stringify(state.initials.list[index]));
      return loadFetch('Getting cell text', {
        method: 'POST',
        body,
      }, (response: GatewayResponse) => {
        if (response.Error) return commit('setError', response.Error);

        return commit('setCell', {
          param: 'text',
          index,
          value: response.about,
        });
        // return commit('setInitials', { response });
      }, commit);
    },
    search({ commit, state, dispatch }): Promise<unknown> {
      // const searchPromises = [state.initials.list[0], state.initials.list[1]].map((initial) => {
      const searchPromises = state.initials.list.map((initial, index) => {
        const body = new FormData();
        body.set('type', 'search');
        body.set('initial', JSON.stringify({ ...initial, ...state.initials.common }));
        return loadFetch('Getting result', {
          method: 'POST',
          body,
        }, (response: GatewayResponse) => {
          if (response.Error) return commit('setError', response.Error);

          // return commit('setInitials', { response });
          if (response.request_id) {
            return dispatch('getResult', {
              initial,
              requestId: response.request_id,
              index,
            });
          }

          if ((window as {WTV_HOTELS?: number[]}).WTV_HOTELS) {
            commit('setCell', {
              param: 'regions',
              index,
              value: response.result?.hotel[0]?.regioncode,
            });
            commit('setCell', {
              param: 'subregions',
              index,
              value: response.result?.hotel[0]?.subregioncode,
            });
          }
          // console.log(initial);

          commit('setResult', { initial, result: response.result });
          return response;
        }, commit).then((response) => dispatch('getFirstHotel', response));
      });
      commit('setSearchPromises', searchPromises);

      return Promise.all(searchPromises);
    },

    getFirstHotel({ dispatch }, resultResponse: GatewayResponse) {
      if (resultResponse?.result?.hotel && resultResponse?.result?.hotel?.length === 0) {
        return Promise.reject(resultResponse);
      }
      const hotelcode: string = resultResponse?.result?.hotel[0].hotelcode as string;
      return dispatch('getHotel', hotelcode);
    },

    getHotel({ commit }, hotelcode) {
      return loadFetch('Getting hotel info', { type: 'hotel', hotelcode }, (response: GatewayResponse) => {
        if (response.Error) return commit('setError', response.Error);

        if (response.hotel) commit('updateHotelList', { hotelcode, ...response.hotel as object });

        return response;
      }, commit);
    },

    getResult({ commit, state, dispatch }, { initial, requestId, index }) {
      const body = new FormData();
      body.set('type', 'result');
      body.set('initial', JSON.stringify({ ...initial, ...state.initials.common }));
      body.set('request_id', requestId);
      return loadFetch(`Getting result ${index}`, {
        method: 'POST',
        body,
      }, (response: GatewayResponse) => {
        if (response.Error) return commit('setError', response.Error);

        if (response.status) {
          commit('setStatus', response.status);

          if (state.status?.state === 'searching') {
            return new Promise((resolve) => {
              setTimeout(() => resolve(dispatch('getResult', { initial, requestId })), 2000);
            });
          }

          commit('setResult', { initial, result: response.result });
        }

        return response;
      }, commit);
    },

    actualize({ commit }, tour) {
      return loadFetch('Actualizing tour', {
        type: 'actualize',
        tourid: tour.tourid,
      }, (response: GatewayResponse) => {
        if (response.Error) return commit('setError', response.Error);

        if (response.tour) {
          const responseTour = response.tour as object;
          commit('setTour', { ...tour, ...responseTour });
        }

        return response;
      }, commit);
    },

    actualizeDetail({ state, commit, getters }) {
      if (
        state.tour?.detail
          || getters.isLoading('Actualizing tour details')) return Promise.reject();

      return loadFetch('Actualizing tour details', {
        type: 'actualize_detail',
        tourid: state.tour?.tourid as string,
      }, (response: GatewayResponse) => {
        if (response.Error) return commit('setError', response.Error);

        if (response.tour) {
          commit('setTour', { ...state.tour, detail: response.tour });
        }

        return response;
      }, commit);
    },

    sendFeedback({
      state, getters, commit, dispatch,
    }) {
      // console.log('hi');
      const tourInfo = Object.fromEntries(
        // @ts-ignore
        Object.entries(state.tour).filter((row) => [
          'countryname',
          'departurename',
          'flydate',
          'fuelcharge',
          'hotelname',
          'hotelregionname',
          'meal',
          'nights',
          'operatorname',
          'placement',
          'price',
          'room',
        ].includes(row[0])),
      );

      const params = {
        type: 'register_feedback',
        ...tourInfo,
        ...state.feedback,
        flight: getters.flightString,
      };
      // if (['pm', 'main-pm'].includes(getters.context)) params.tvnet = 'pm';

      // console.log(params);
      // @ts-ignore

      return loadFetch('Actualizing tour details', params, (response) => {
        if (response.Error) {
          commit(
            'setError',
            'Ошибка! Перезагрузите страницу и попробуйте еще раз',
          );
        }
        commit('setSent');
        setTimeout(() => commit('setSent', false), 10000);

        dispatch('sendStats', {
          cell: state.initials.list[state.cellIndex as number],
          type: 'order',
        });

        // if (response.ym) reachGoal(response.ym, 'tourOrder');
      }, commit);
    },

    sendStats({ commit }, { cell, type }) {
      // console.log(platform);
      return loadFetch('Sending stats', {
        type: 'register_stats',
        regions: cell.regions,
        subregions: cell.subregions,
        event: type,
        browser: platform.name || '',
        browserversion: platform.version || '',
        os: platform?.os?.family || '',
        osversion: platform?.os?.version || '',
      }, (response: GatewayResponse) => {
        if (response.Error) return commit('setError', response.Error);

        return response;
      }, commit);
    },
  },
  modules: {
  },
});
